import { Injectable } from '@angular/core';
import {HttpService} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {PracticeModel} from '../../models/practice/practice.model';

@Injectable({
  providedIn: 'root'
})
export class PracticeService extends HttpService{

    getPracticeList(): Observable<iResponseList<PracticeModel>> {
        return this.get('practices/').pipe(
            map((response: iResponseList<PracticeModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    postPractice(practice: PracticeModel): Observable<iResponse<PracticeModel>> {
        return this.post('practices', practice).pipe(
            map((response: iResponse<PracticeModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    updatePractice(practice: PracticeModel): Observable<iResponse<PracticeModel>> {
        return this.put(`practices/${practice.id}`, practice).pipe(
            map((response: iResponse<PracticeModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }

    deletePractice(id: string): Observable<iResponse<PracticeModel>> {
        return this.delete(`practices/${id}`).pipe(
            map((response: iResponse<PracticeModel>) => {
                return response
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
